import script from "./CaseStudyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStudyDetail.vue?vue&type=script&setup=true&lang=js"

import "./CaseStudyDetail.vue?vue&type=style&index=0&id=496a2895&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496a2895"]])

export default __exports__